// import './App.css';
import { useEffect, useState } from "react";
import Modal from "react-modal";
import { useHistory, useParams } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";

import { getOrganization } from "./../services/api";
import AssessmentsTable from "../components/assessmentsTable";
import AssessmentForm from "../components/assessmentForm";

import { FaTimes } from "react-icons/fa";

function Organization() {
  let history = useHistory();

  let { organizationId } = useParams();

  const [organization, setOrganization] = useState(null);

  const [editAssessment, setEditAssessment] = useState(null);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getOrganization(organizationId)
      .then((res) => {
        setOrganization(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onEditAssessment = (assessment) => {
    if (!assessment.id) {
      setEditAssessment(assessment);
      return;
    }
    history.push(`/organization/${organizationId}/assessment/${assessment.id}`);
  };

  const onEditDataAssessment = (assessment) => {
    setEditAssessment(assessment);
  };

  const onDeleteAssessment = (assessment) => {};

  const onSaveSuccess = (assessment) => {};

  const closeModal = () => {
    setEditAssessment(null);
  };

  return (
    <LoadingOverlay active={loading} spinner>
      {organization && (
        <AssessmentsTable
          assessments={organization.assessments}
          onEdit={onEditAssessment}
          onDelete={onDeleteAssessment}
          onEditData={onEditDataAssessment}
        />
      )}
      <Modal
        isOpen={editAssessment}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        className="modalEdit"
        style={{ overlay: { zIndex: 1000 } }}
      >
        <div className="closeModal">
          <FaTimes className="icon-limber" size="1.5em" onClick={() => closeModal()} />
        </div>
        {editAssessment && (
          <AssessmentForm assessment={editAssessment} organizationId={organizationId} onSaveSuccess={onSaveSuccess} />
        )}
      </Modal>
    </LoadingOverlay>
  );
}

export default Organization;
